import { AxiosRequestConfig } from 'axios';

interface IApiEndpoints {
  [controller: string]: {
    [endpoint: string]: AxiosRequestConfig;
  };
}

const api: IApiEndpoints = {
  auth: {
    getToken: {
      url: '/oauth/token',
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
    checkTotp: {
      url: '/oauth/check-totp',
      method: 'POST',
    },
    setupTotp: {
      url: '/oauth/setup-totp',
      method: 'POST',
    },
    getCurrentAccount: {
      url: '/api/v1/account/get-current-authorized',
      method: 'GET',
    },
  },
  roles: {
    getList: {
      url: '/api/v1/admin/roles/',
      method: 'GET',
    },
    updateRole: {
      url: '/api/v1/admin/role/{userId}/{roleId}',
      method: 'PATCH',
    },
  },
  users: {
    getList: {
      url: '/api/v1/admin/users',
      method: 'GET',
    },
    getItem: {
      url: '/api/v1/admin/get/{userId}',
      method: 'GET',
    },
    block: {
      url: '/api/v1/admin/block/{userId}',
      method: 'PATCH',
    },
    unblock: {
      url: '/api/v1/admin/unblock/{userId}',
      method: 'PATCH',
    },
    makeadmin: {
      url: '/api/v1/admin/makeadmin/{userId}',
      method: 'PATCH',
    },
    deleteUser: {
      url: '/api/v1/admin/account/{userId}',
      method: 'DELETE',
    },
    updateUser: {
      url: '/api/v1/admin/account/{userId}',
      method: 'PATCH',
    },
    unlinkDiscord: {
      url: '/api/v3/admin/accounts/{userId}/services/discord/unlink',
      method: 'POST',
    },
    verifyUser: {
      url: 'api/v3/admin/accounts/{userId}/marks',
      method: 'POST',
    },
    createUser: {
      url: '/api/v1/admin/account',
      method: 'POST',
    },
    recoverPassword: {
      url: '/api/v1/account/recover',
      method: 'POST',
    },
    makeuser: {
      url: '/api/v1/admin/makeuser/{userId}',
      method: 'PATCH',
    },
    getIsPlus: {
      url: '/api/v3/admin/account/{userId}/plus',
      method: 'GET',
    },
    addPlus: {
      url: '/api/v3/admin/plus/trial/give',
      method: 'POST',
    },
    continuePlus: {
      url: 'api/v3/admin/plus/trial/prolongate',
      method: 'POST',
    },
    revokePlus: {
      url: 'api/v3/admin/plus/trial/revoke',
      method: 'POST',
    },
    getPlusHistory: {
      url: 'api/v3/admin/account/{accountId}/plus_history',
      method: 'GET',
    },
    getNicknameHistory: {
      url: '/api/v3/admin/account/{userId}/nickname/history',
      method: 'POST',
    },
    getAccountChangeHistory: {
      url: '/api/v3/admin/account/{userId}/changelog',
      method: 'POST',
    },
    getModerationHistory: {
      url: '/api/v3/admin/accounts/{accountId}/moderation-history',
      method: 'GET',
    },
    getDevices: {
      url: '/api/v3/admin/account/{accountId}/devices',
      method: 'POST',
    },
  },
  registrationIps: {
    getList: {
      url: '/api/v3/admin/registration_ips',
      method: 'POST',
    },
    ban: {
      url: '/api/v3/admin/account/registration_ips/ban',
      method: 'POST',
    },
    unban: {
      url: '/api/v3/admin/account/registration_ips/unban',
      method: 'POST',
    },
  },
  blockedEmailDomains: {
    create: {
      url: '/api/v3/admin/blocked_email_domains',
      method: 'POST',
    },
    search: {
      url: '/api/v3/admin/blocked_email_domains/search',
      method: 'POST',
    },
    updateStatus: {
      url: '/api/v3/admin/blocked_email_domains/status',
      method: 'PATCH',
    },
  },
  profile: {
    getUserGames: {
      url: '/api/v3/public/profile/{accountId}/games',
      method: 'POST',
    },
  },
  push: {
    getList: {
      url: '/api/v3/admin/push-surveys',
      method: 'GET',
    },
    create: {
      url: '/api/v3/admin/push-surveys',
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
    getSurveyTopic: {
      url: 'api/v3/admin/i18n/pushSurveyTopic',
      method: 'GET',
    },
    getSurveyText: {
      url: 'api/v3/admin/i18n/pushSurveyText',
      method: 'GET',
    },
    getSurveyButton: {
      url: 'api/v3/admin/i18n/pushSurveyButton',
      method: 'GET',
    },
  },
  games: {
    getList: {
      url: '/api/v1/admin/game/getAll',
      method: 'GET',
    },
    getItem: {
      url: '/api/v1/admin/game/get/{gameId}',
      method: 'GET',
    },
    add: {
      url: '/api/v1/admin/game/add',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    update: {
      url: '/api/v1/admin/game/update',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    checkCode: {
      url: '/api/v3/admin/game/suggest/code?name={code}',
      method: 'GET',
    },
    setTags: {
      url: '/api/v1/admin/game/{gameId}/setTags',
      method: 'POST',
    },
    image: {
      url: '/api/v1/admin/game/image',
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
    delete: {
      url: '/api/v1/admin/game/delete/{gameId}',
      method: 'DELETE',
    },
  },
  posts: {
    getList: {
      url: '/api/v1/admin/posts',
      method: 'GET',
    },
    getTopList: {
      url: '/api/v2/feed/open/top/bygame/{gameId}',
      method: 'GET',
    },
    getListByUser: {
      url: '/api/v1/feed/open/byuser/{userId}',
      method: 'GET',
    },
    getItem: {
      url: '/api/v1/admin/posts/{postId}',
      method: 'GET',
    },
    setStatus: {
      url: 'api/v1/admin/{postId}/viewStatus',
      method: 'PATCH',
    },
    getMarks: {
      url: 'api/v3/moderation_marks',
      method: 'GET',
    },
    postMarks: {
      url: 'api/v3/moderation_marks',
      method: 'POST',
    },
    delMarks: {
      url: 'api/v3/moderation_marks',
      method: 'DELETE',
    },
  },
  dictionary: {
    getList: {
      url: '/api/v1/dictionary/platform',
      method: 'GET',
    },
  },
  comments: {
    getListForPost: {
      url: '/api/v1/admin/comment/open/p/{postId}/comments',
      method: 'GET',
    },
    getListForComment: {
      url: '/api/v1/admin/comment/open/c/{commentId}/comments',
      method: 'GET',
    },
    getUsersComments: {
      url: 'api/v1/admin/account/{accountId}/comments',
      method: 'POST',
    },
    block: {
      url: '/api/v1/admin/comment/{commentId}/block',
      method: 'GET',
    },
    unblock: {
      url: '/api/v1/admin/comment/{commentId}/unblock',
      method: 'GET',
    },
  },
  likes: {
    getAccountListForPost: {
      url: '/api/v1/posts/open/{postId}/likes',
      method: 'GET',
    },
  },
  spam: {
    getList: {
      url: '/api/v2/admin/spam/p/getSpams',
      method: 'GET',
    },
    approve: {
      url: '/api/v1/spam/admin/p/{postId}/approve',
      method: 'POST',
    },
    showComplainers: {
      url: '/api/v1/spam/admin/p/{itemId}/showComplainers',
      method: 'GET',
    },
    getPostComplaintReasons: {
      url: '/api/v2/admin/posts/{itemId}/claims',
      method: 'POST',
    },
    getCommentComplaintReasons: {
      url: '/api/v2/admin/comments/{itemId}/claims',
      method: 'POST',
    },
    getUserComplaintReasons: {
      url: '/api/v3/admin/accounts/{accountId}/claims',
      method: 'POST',
    },
    getComments: {
      url: '/api/v2/admin/spam/c/getSpams',
      method: 'GET',
    },
    getUsers: {
      url: '/api/v1/admin/complained',
      method: 'GET',
    },
    complainView: {
      url: '/api/v1/admin/complain/view/{id}',
      method: 'GET',
    },
    approveComment: {
      url: '/api/v1/spam/admin/c/{commentId}/approve',
      method: 'POST',
    },
    showCommentComplainers: {
      url: '/api/v1/spam/admin/c/{itemId}/showComplainers',
      method: 'GET',
    },
    getStatuses: {
      url: 'api/v1/admin/spam/s/getSpams',
      method: 'POST',
    },
    approveStatus: {
      url: '/api/v1/admin/spam/s/{statusId}/approve',
      method: 'POST',
    },
    getUserChatClaims: {
      url: '/api/v3/admin/accounts/{accountId}/chat/claims',
      method: 'POST',
    },
    getUserMessages: {
      url: '/api/v3/admin/accounts/{accountId}/messages',
      method: 'POST',
    },
    getUserSuspiciousChats: {
      url: '/api/v3/admin/accounts/{accountId}/chat/suspicious',
      method: 'POST',
    },
  },
  mentionsOfficialAccount: {
    getPost: {
      url: '/api/v3/admin/mention/post/all',
      method: 'POST',
    },
    getComment: {
      url: '/api/v3/admin/mention/comment/all',
      method: 'POST',
    },
    checkPost: {
      url: '/api/v3/admin/mention/post/{postId}/check',
      method: 'POST',
    },
    checkAllPosts: {
      url: '/api/v3/admin/mention/post/all/check',
      method: 'POST',
    },
    checkComment: {
      url: '/api/v3/admin/mention/comment/{commentId}/check',
      method: 'POST',
    },
    checkAllComments: {
      url: '/api/v3/admin/mention/comment/all/check',
      method: 'POST',
    },
    replyToPost: {
      url: '/api/v2/comments/p/{postId}/comment',
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
    },
    replyToComment: {
      url: '/api/v2/comments/c/{commentId}/comment',
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
    },
  },
  featuring: {
    create: {
      url: '/api/v1/admin/promotion',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    update: {
      url: '/api/v1/admin/promotion/{promotionId}',
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    block: {
      url: '/api/v1/admin/promotion/block/{promotionId}',
      method: 'PATCH',
    },
    unblock: {
      url: '/api/v1/admin/promotion/unblock/{promotionId}',
      method: 'PATCH',
    },
    getList: {
      url: '/api/v1/admin/promotion/list',
      method: 'GET',
    },
  },
  activity: {
    getList: {
      url: '/api/v3/admin/activity/promo/list',
      method: 'POST',
    },
    create: {
      url: '/api/v3/admin/activity/promo',
      method: 'POST',
    },
    edit: {
      url: '/api/v3/admin/activity/promo/{promoId}',
      method: 'PUT',
    },
  },
  promotion: {
    getList: {
      url: '/api/v3/admin/game/promo/list',
      method: 'POST',
    },
    create: {
      url: '/api/v3/admin/game/promo',
      method: 'POST',
    },
    edit: {
      url: '/api/v3/admin/game/promo/{promoId}',
      method: 'PUT',
    },
  },
  suggest: {
    getList: {
      url: '/api/v1/admin/game/suggested',
      method: 'GET',
    },
    approve: {
      url: '/api/v1/admin/game/suggest/{suggestId}/approve',
      method: 'POST',
    },
    gameExist: {
      url: '/api/v1/admin/game/suggest/{suggestId}/gameExist',
      method: 'POST',
    },
    reject: {
      url: '/api/v1/admin/game/suggest/{suggestId}/reject',
      method: 'POST',
    },
  },
  tribes: {
    getList: {
      url: '/api/v3/admin/tribes',
      method: 'POST',
    },
    getMembersList: {
      url: '/api/v3/admin/tribe/{tribeId}/members',
      method: 'POST',
    },
    deleteTribe: {
      url: '/api/v3/admin/tribe/{tribeId}',
      method: 'DELETE',
    },
    editTribe: {
      url: '/api/v3/admin/tribe/{tribeId}',
      method: 'PATCH',
    },
    blockTribe: {
      url: '/api/v3/admin/tribe/{tribeId}/block',
      method: 'POST',
    },
    unblockTribe: {
      url: '/api/v3/admin/tribe/{tribeId}/unblock',
      method: 'POST',
    },
    getClaimsByTribe: {
      url: '/api/v3/admin/tribes/{tribeId}/claims',
      method: 'POST',
    },
    banMember: {
      url: '/api/v3/admin/tribe/{tribeId}/members/{accountId}/ban',
      method: 'POST',
    },
    unbanMember: {
      url: '/api/v3/admin/tribe/{tribeId}/members/{accountId}/unban',
      method: 'POST',
    },
  },
  chats: {
    getChat: {
      url: '/api/v3/admin/chat/{chatId}',
      method: 'POST',
    },
    deleteMessage: {
      url: '/api/v3/admin/chat/{chatId}/message/{messageId}',
      method: 'DELETE',
    },
  },
  experiments: {
    getList: {
      url: '/api/v1/admin/experiments',
      method: 'GET',
    },
  },
};

export default api;
